import React, { useContext, useMemo, useState } from 'react'
import DropdownSelect from 'app/components/dropdown'
import { AuthContext } from 'app/modules/user'
import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'
import { maskCasualPasswordContent } from 'app/modules/user/features/profile/casual-passwords/helpers'
import Button from 'app/modules/shared/components/button'
import { InputGroup } from 'react-bootstrap'

type CasualPasswordSelectProps = {
  id: string
  onChange: (value: string) => void
}
export function PasswordSelect({ id, onChange }: CasualPasswordSelectProps) {
  const { _t } = useTypedTranslation()
  const { user } = useContext(AuthContext)
  const [showPassword, setShowPassword] = useState(false)

  const items = useMemo(() => {
    return (user?.casualPasswords ?? []).map((item) => ({
      value: item.content,
      name: item.description
        ? `${maskCasualPasswordContent(item.content)} — ${item.description}`
        : maskCasualPasswordContent(item.content),
    }))
  }, [user?.casualPasswords])

  return (
    <InputGroup>
      <div className="flex-grow-1">
        <DropdownSelect
          id={id}
          searchable
          items={items}
          onClick={onChange}
          onSearchChange={onChange}
          placeholder={_t('custom-password')}
          type={showPassword ? 'text' : 'password'}
        />
      </div>
      <Button
        id={id}
        variant="input-group-suffix"
        onClick={() => setShowPassword(!showPassword)}
        aria-label={showPassword ? _t('hide') : _t('show')}
      >
        <i className={showPassword ? 'ds3-icon ds3-eye-closed' : 'ds3-icon ds3-eye'} aria-hidden={true} />
      </Button>
    </InputGroup>
  )
}
